import { Typography, Box, useTheme } from "@mui/material";
import { tokens } from "../theme";

const Header = ({ title, subtitle }) => {
  const theme = useTheme();
  const colors = tokens(theme.palette.mode);
  return (
    <Box mb='10px' mt='6px' sx={{display:{xl:'block', lg:'block', md:'block', sm:'block', xs:'none'}}}>
      <Typography variant="h4" color={colors.grey[100]} fontWeight="bold" sx={{ m: "0 0 0px 0" }}>
        {title}
      </Typography>
      <Typography variant="h5" color={'#00ac73'}>
        {subtitle}
      </Typography>
    </Box>
  );
};

export default Header;
